module.exports = __webpack_public_path__ + "static/img/portrait-male-white.d3b32cd5.png";